import { render, staticRenderFns } from "./ClassesChart.vue?vue&type=template&id=9dc9cb42&"
import script from "./ClassesChart.vue?vue&type=script&lang=js&"
export * from "./ClassesChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports